// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button_iconButton__x41B8","dense":"icon-button_dense__30+hH"};